import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../providers/AuthProvider';

interface ProtectedRouteProps {
    allowedRoles?: string[]; // es: ["admin", "editor"]
}

export const ProtectedRoute = ({allowedRoles}: ProtectedRouteProps) => {
    const { user, loading, grants } = useAuth();

    if (loading) return <div className="App container">Caricamento sessione...</div>; // Blocca il flicker!

    if (!user) return <Navigate to="/login" />;

    // FE-T-012: with allowedRoles set, a user without any matching grant (including none at all) is denied.
    if (allowedRoles) {
        const hasAccess = grants.some((role: string) => allowedRoles.includes(role));
        if (!hasAccess) {
            return <Navigate to="/unauthorized"/>
        }
    }

    return <Outlet />;
};
